import { PlanSibling } from '@anm/api/modules/pricing';
import isMobile from '@anm/helpers/is/isMobile';
import noop from 'lodash/fp/noop';
import { useEffect, useState, FC } from 'react';

import PeriodSwitcher, { PeriodSwitcherProps } from '../PeriodSwitcher';

import DesktopTable from './DesktopTable';
import PricingColumn, { PricingColumnProps } from './PricingColumn';
import { PricingTableWrapper } from './Wrapper';
import useSiblingSwitcher from './hooks/useSiblingSwitcher';
import useSiblingsList from './hooks/useSiblingsList';
import { PricingTablePlan } from './types';
export * from './types';

export type PricingTableProps = Pick<PricingColumnProps, 'onGetPlanClick' | 'onPeriodChange'> &
  Pick<PeriodSwitcherProps, 'seasonalDiscount'> & {
    list: PricingTablePlan[];
  };

const PricingTable: FC<PricingTableProps> = ({
  list,
  seasonalDiscount,
  onGetPlanClick = noop,
  onPeriodChange = noop
}) => {
  const { isAnnual } = list[0];
  const [isMobileLocal, setIsMobile] = useState(false);

  const [{ localList, siblings }, { changeSibling }] = useSiblingsList(list);
  const { onSiblingChange } = useSiblingSwitcher({ change: changeSibling, siblings });
  const siblingDropdownOptions = siblings?.map<PlanSibling>(({ sibling }) => sibling!);

  useEffect(() => {
    setIsMobile(isMobile());
  }, []);

  return (
    <>
      <PeriodSwitcher seasonalDiscount={seasonalDiscount} isAnnual={isAnnual} onChange={onPeriodChange} />

      {isMobileLocal ? (
        <PricingTableWrapper>
          {localList.map(plan => (
            <PricingColumn
              key={plan.id}
              siblingDropdownOptions={siblingDropdownOptions}
              {...{ onGetPlanClick, onPeriodChange, onSiblingChange, ...plan }}
            />
          ))}
        </PricingTableWrapper>
      ) : (
        <DesktopTable
          list={localList}
          siblingDropdownOptions={siblingDropdownOptions}
          {...{ onGetPlanClick, onPeriodChange, onSiblingChange }}
        />
      )}
    </>
  );
};

export default PricingTable;
